<template>
  <div class="verification-warning-container">
    <img src="~static/recovery-illustration.svg" alt="">
    <div class="verification-warning-container__content">
      <header>{{ i18n.t('recovery:warning.header') }}</header>
      <p>{{ i18n.t('recovery:warning.description') }}</p>
    </div>
    <action-bar>
      <ul>
        <li class="primary" @click="proceed">{{ i18n.t('recovery:warning.continue') }}</li>
      </ul>
    </action-bar>
  </div>
</template>

<script>
export default {
  props: ['screenParams'],
  methods: {
    proceed () {
      this.$store.dispatch('next', this.screenParams.nextScreenRoute)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/mixins.scss';

  .verification-warning-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;

    img {
      max-height: 112px;
      height: 112px;
    }

    &__content {
      max-width: 316px;
      margin: 20% auto 0;

      @include desktop {
        margin: 10px auto 0;
      }
      
      @include desktop-big {
        margin: 40px auto 0;
      }


      header {
        color: $blackTextColor;
        font-family: $headerFontFamily;
        font-size: 25px;
        font-weight: $boldFontWeight;
        letter-spacing: 0;
        line-height: 32px;
        text-align: center;
        white-space: pre-line;
      }

      p {
        color: $inputHintColor;
        font-family: $headerFontFamily;
        font-size: 1rem;
        font-weight: $lightFontWeight;
        letter-spacing: 0;
        line-height: 22px;
        text-align: center;
        margin-top: 15px;
      }
    }

    ul {
      @include button-list;
      margin: auto auto 0;
      li {
        border-radius: 30px !important;
        width: 100% !important;
        text-align: center !important;
        font-weight: 700 !important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/screens/verification-recovery-flow/verification-warning.vue